import moment from 'moment';
export default function getGoogleCalendarUri({
  title,
  desc,
  location = 'Cap 60',
  start,
  end,
}) {
  const data = {
    action: 'TEMPLATE',
    text: title,
    details: desc,
    location: location,
    dates:
      moment(start).format('YYYYMMDDTHHmmss') +
      '/' +
      moment(end).format('YYYYMMDDTHHmmss'),
  };
  return encodeURI(
    `https://www.google.com/calendar/render?action=${data.action}&text=${data.text}&details=${desc}&location=${data.location}&dates=${data.dates}`
  );
}
